// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import { Turbo } from "@hotwired/turbo-rails"
import "controllers"
import "analytics"
import { confirmAction } from "confirmation_modal"

Turbo.config.forms.confirm = confirmAction
